export default "__VITE_ASSET__D7OqM7fI__"